import type { Faq } from '../types/kit';

export const faqs: Faq[] = [
  {
    question: '¿Necesito experiencia?',
    answer: ['No.', 'Los contenidos están planteados desde los fundamentos y avanzan progresivamente.'],
  },
  {
    question: '¿Tengo que hacer los tres negocios?',
    answer: ['No. De hecho, recomendamos lo contrario.', 'Analizá los tres. Elegí uno. Ejecutalo.'],
  },
  {
    question: '¿Necesito mucho dinero?',
    answer: [
      'Depende del modelo.',
      'Airbnb mediante administración de propiedades puede requerir relativamente poco capital inicial.',
      'El arbitraje requiere capital operativo.',
      'Productos digitales requiere principalmente herramientas y presupuesto para realizar tests publicitarios.',
    ],
  },
  {
    question: '¿Voy a ganar USD 1.000?',
    answer: [
      'No existe una cifra garantizada.',
      'Los resultados dependen de capital, mercado, ejecución, experiencia, costos, tiempo y muchas otras variables.',
      'El KIT te proporciona información, herramientas y planes de acción; no una promesa de ingresos.',
    ],
  },
  {
    question: '¿Es un curso en video?',
    answer: [
      'El núcleo del KIT está compuesto por guías y recursos digitales diseñados para consultar y ejecutar paso a paso.',
    ],
  },
  {
    question: '¿Puedo leerlo desde el celular?',
    answer: ['Sí. Los materiales digitales pueden consultarse desde dispositivos compatibles con el formato entregado.'],
  },
  {
    question: '¿Sirve solamente para Argentina?',
    answer: [
      'Está especialmente pensado desde una perspectiva argentina y algunas herramientas o ejemplos son locales.',
      'Varios principios pueden aplicarse en otros mercados, pero plataformas, regulación, impuestos y medios de pago pueden variar según el país.',
    ],
  },
  {
    question: '¿Cómo lo recibo?',
    answer: ['Después de completar la compra, accedés a las instrucciones de entrega digital correspondientes.'],
  },
];
